import React, { Fragment } from "react";
import { formatCurrency, intFormat } from "../../../../../js/shared/utils";
import { formatDateToLocalDate } from "./../../../shared/utils";

const ItemOfferDetails = ({ offer, ...props } = props) => (
	<Fragment>
		<div className="item-offer-details--header text-center">
			<p>
				<strong>Em negociação</strong>
			</p>
			<p>
				<span className="header-info">
					No momento, não é possível editar ou remover esta oferta, pois ela está em negociação.
				</span>
			</p>
		</div>

		{offer.sales.map((sale, idx) => {
			return (
				<Fragment key={idx}>
					{idx >= 1 && <hr />}
					<div className="item-offer-details--content no-padding">
						<div className="col-xs-16 col-md-8 miles-info">
							<p>
								{intFormat(sale.miles)} milhas: <strong>{formatCurrency(sale.total)}</strong>
							</p>
							<p>
								1.000 milhas: <strong>{formatCurrency(sale.price)}</strong>
							</p>
						</div>
						<div className="col-xs-16 col-md-8 transaction-info">
							<p>
								Transação: <strong>{sale.transaction}</strong>
							</p>
							<p>
								Data: <strong>{formatDateToLocalDate(sale.saleDate)}</strong>
							</p>
						</div>
					</div>
				</Fragment>
			);
		})}
	</Fragment>
);

export default ItemOfferDetails;
